<script setup lang="ts">
import { toRefs } from "vue";
import JSONtoHTML from "@/components/forms/SharedComponents/WYSIWYG/JSONtoHTML.vue";
import { useTodoInstructions } from "@/composables/useTodoInstructions";

const props = withDefaults(
  defineProps<{
    todoId: string;
    applicationId?: string;
  }>(),
  {
    applicationId: undefined,
  },
);

const { todoId, applicationId } = toRefs(props);
const { instructions } = useTodoInstructions(todoId, applicationId);
</script>

<template>
  <JSONtoHTML v-if="instructions" :tiptap-json="instructions" data-test="todo-instructions" />
</template>
